import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';

const SingleAuditLogDetails = () => {
  const { auditLogId } = useParams();
   // Ensure we only get the numeric part
  const decodedId = auditLogId ? atob(auditLogId) : auditLogId;
  const id = decodedId.replace(/\D/g, '');
  const [auditLogDetails, setAuditLogDetails] = useState(null);

  const [columns, setColumnDetails] = useState([]);

  useEffect(() => {
    fetchAuditLogDetails();
  }, [auditLogId]);

  const fetchAuditLogDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.audit_log}${id}/`, { headers });
      const extractedColumns = [...Object.keys(response.data)];
      const excludedColumns = ['id', 'created_at', 'updated_at'];

      const columnsArray = [...extractedColumns]
        .filter((column) => !excludedColumns.includes(column))
        .map((column) => {
          return {
            label: column.charAt(0).toUpperCase() + column.slice(1).replace('_', ' '),
            field: column,
          };
        });

      setColumnDetails(columnsArray);
      setAuditLogDetails(response.data);
    } catch (error) {
      console.error('Error fetching audit log details:', error);
    }
  };

  return (
    <div>
      {auditLogDetails ? (
        <SingleItemDetailTemplate details={auditLogDetails} columns={columns} />
      ) : (
        <p>Loading audit log details...</p>
      )}
    </div>
  );
};

export default SingleAuditLogDetails;